import React from "react";
import { Link } from "react-router-dom";
import "../../style/hub.css";
import { LostArkIcon, PubgIcon } from "./icons";

export default function HiddenHub() {
  return (
    <div className="hub-page">
      <div className="hub-buttons">
        {/* /bg는 choco-proxy가 다른 컨테이너로 라우팅하는 경로라 풀 페이지 이동 필요 */}
        <a href="/bg" className="hub-square-button hub-square-button--pubg">
          <PubgIcon />
          <span className="hub-label">배그</span>
        </a>
        <Link to="/lostark-party" className="hub-square-button hub-square-button--lostark">
          <LostArkIcon />
          <span className="hub-label">로아</span>
        </Link>
      </div>
    </div>
  );
}
